module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/qme-a3f0d9ec6820f165ab138d745f4436b7.png";